import { render, staticRenderFns } from "./PageMigrationVerify.vue?vue&type=template&id=04d1285a&"
import script from "./PageMigrationVerify.vue?vue&type=script&lang=js&"
export * from "./PageMigrationVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d1285a')) {
      api.createRecord('04d1285a', component.options)
    } else {
      api.reload('04d1285a', component.options)
    }
    module.hot.accept("./PageMigrationVerify.vue?vue&type=template&id=04d1285a&", function () {
      api.rerender('04d1285a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/PageMigrationVerify.vue"
export default component.exports